<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="修改商品"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="驳回理由" v-if="this.authType == 2">
				<el-input v-model="item.memo" placeholder="" class="el-input-default-width-220"></el-input>
			</el-form-item>
			<el-form-item label="商品名称" prop="name">
				<el-input ref="goodsName" v-model="item.name" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="副标题">
				<el-input v-model="item.caption" placeholder="请输入副标题"></el-input>
			</el-form-item>
<!--			<el-form-item label="是否上架">-->
<!--				<el-switch :active-value="'1'" :inactive-value="'0'" v-model="item.is_marketable" active-color="#13ce66" inactive-color="#cccccc">-->
<!--				</el-switch>-->
<!--			</el-form-item>-->
			<el-form-item label="所属品牌">
				<el-select v-model="item.brand_id" filterable placeholder="请选择">
					<el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="平台分类">
				<el-cascader v-model="item.product_category_id" placeholder="请选择" :options="adminCategoryList"
					:props="filterProps" clearable></el-cascader>
			</el-form-item>
			<el-form-item label="商品分类">
				<el-cascader v-model="item.supplier_category_id" placeholder="请选择"
					:options="supplierCategoryList" :props="filterProps" clearable></el-cascader>
			</el-form-item>
			<el-form-item label="运费模板" prop="delivery_id">
				<el-select v-model="item.delivery_id" filterable placeholder="请选择">
					<el-option v-for="item in deliverys" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
<!--			<el-form-item label="选择模板">-->
<!--				<el-select v-model="item.industryTemplateId" filterable placeholder="请选择">-->
<!--					<el-option v-for="item in industryTemplateList" :key="item.id" :label="item.name" :value="item.id">-->
<!--					</el-option>-->
<!--				</el-select>-->
<!--			</el-form-item>-->

			<el-form-item :label="list.itemKey" v-for="(list,index) in parameter">
				<el-input v-if="list.dataType == 1" v-model="list.itemValue" placeholder="请输入参数"></el-input>
				<el-date-picker v-else-if="list.dataType == 2" v-model="list.itemValue" type="date" placeholder="选择日期">
				</el-date-picker>
				<el-date-picker v-else-if="list.dataType == 3" v-model="list.itemValue" type="datetime"
					placeholder="选择日期时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="商品编码">
				<el-input v-model="item.sku_no" placeholder="请输入商品编码"></el-input>
			</el-form-item>
			<!-- <el-input v-model="item.caption" placeholder="请输入商品规格"></el-input> -->
			<div>
				<div class="goods-spec">
					<el-button size="big" type="primary" @click="addPrivateSpec">点击添加规格</el-button>
<!--					<el-link type="primary" @click="addPrivateSpec" class="goods-spec-add" style="">添加规格</el-link>-->
				</div>
				<div class="goods-container" v-for="(attr, index) in privateGoodsItem" :key="index">
					<div class="goods-content">
						<div class="goods-content-box">
							<div class="goods-content-left">
								<el-form-item label="规格名">
									<el-input v-model="attr.privateSpecName" placeholder="请输入规格名"></el-input>
								</el-form-item>
								<el-form-item label="规格值">
									<el-tag v-for="tag in attr.dynamicTags" :key="tag" closable
										:disable-transitions="false" @close="handleClose(tag, attr)">
										{{tag}}
									</el-tag>
									<!--  inputVisible控制是否显示  inputValue值 -->
									<!-- @keyup.enter.native点击回车的时候 判断是否有值决定是否隐藏 -->
									<!-- input失焦blur的时候 判断是否有值决定是否隐藏-->
									<el-input class="input-new-tag" v-show="attr.inputVisible" v-model="attr.inputValue"
										:ref="`saveTagInput${index}`" size="small"
										@keyup.enter.native="handleInputConfirm(attr.inputValue, attr)"
										@blur="handleInputConfirm(attr.inputValue, attr)"></el-input>
									<el-button v-show="!attr.inputVisible" class="button-new-tag" size="small"
										@click="showInput(attr, index)">+ 添加</el-button>
								</el-form-item>
							</div>
							<div class="goods-content-right">
								<el-link type="danger" @click="delPrivateSpec(index)">删除规格</el-link>
							</div>
						</div>
					</div>
				</div>
				<el-table style="margin-bottom: 22px; margin-top:0;" :data="oneFormBatch" border tooltip-effect="dark">
					<el-table-column label="规格">
						<template slot-scope="scope">
							批量设置
						</template>
					</el-table-column>
					<el-table-column label="图片">
						<template slot-scope="scope">
							<el-upload
									class="single-image single-image-small"
									list-type="single-image"
									:on-success="(value) => uploadSuccess1('oneFormBatch', 'single', value, scope.$index)"
									:before-upload="beforeUpload"
									:show-file-list="false"
									:action="app_url + '/store/uploader/upload'">
								<i class="icon el-icon-plus" v-if="!oneFormBatch[scope.$index].product_image"></i>
								<img :src="oneFormBatch[scope.$index].product_image" v-else>
							</el-upload>
						</template>
					</el-table-column>
					<el-table-column label="销售价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="成本价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.cost"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="市场价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.market_price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="Sku编码">
						<template slot-scope="scope">
							<el-input v-model="scope.row.product_sku_no"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="batchAdd" type="success">批量添加</el-button>
							<el-button @click="batchDel" type="primary">清空</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- <p style="margin:22px 0 10px 0">价格</p> -->
				<el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable"
					:data="tableColumnList.tableBodyList" border tooltip-effect="dark">
					<el-table-column :label="item.propName" :property="item.prop"
						v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
						<template slot-scope="scope">
							<span>{{ scope.row[scope.column.property] }}</span>
						</template>
					</el-table-column>
					<el-table-column label="商品标识">
						<template slot-scope="scope">
							{{scope.row.product_id}}#{{scope.row.unique}}
						</template>
					</el-table-column>
					<el-table-column label="图片">
						<template slot-scope="scope">
							<el-upload
									class="single-image single-image-small"
									list-type="single-image"
									:on-success="(value) => uploadSuccess1('product_image', 'single', value, scope.$index)"
									:show-file-list="false"
									:before-upload="beforeUpload"
									:action="app_url + '/store/uploader/upload'">
								<i class="icon el-icon-plus" v-if="!tableColumnList.tableBodyList[scope.$index].product_image"></i>
								<img :src="tableColumnList.tableBodyList[scope.$index].product_image" v-else>
							</el-upload>
						</template>
					</el-table-column>
					<el-table-column label="销售价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="成本价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.cost"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="市场价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.market_price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="Sku编码">
						<template slot-scope="scope">
							<el-input v-model="scope.row.product_sku_no"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<el-form-item label="商品主图" prop="product_pic_main">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('product_pic_main', 'single', value)"
						:show-file-list="false"
						:before-upload="beforeUpload"
						:action="app_url + '/supplier/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.product_pic_main"></i>
					<img :src="item.product_pic_main" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="细节图" prop="product_images">
				<div>
					<ul class="el-upload-list el-upload-list--picture-card">
						<li :tabindex="index" class="el-upload-list__item is-success" v-for="(src, index) in item.product_images" :key="index">
							<img :src="src" alt="" class="el-upload-list__item-thumbnail">
							<label class="el-upload-list__item-status-label">
								<i class="el-icon-upload-success el-icon-check"></i>
							</label>
							<i class="el-icon-close"></i><i class="el-icon-close-tip">按 delete 键可删除</i>
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview">
									<i class="el-icon-zoom-in"></i></span>
								<span class="el-upload-list__item-delete" @click="delectImage('product_images', index)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</li>
					</ul>
					<el-upload
							style="display: inline"
							:multiple="true"
							:limit="10 - item.product_images.length"
							:action="app_url + '/supplier/uploader/upload'"
							list-type="picture-card"
							:show-file-list="false"
							:before-upload="beforeUpload"
							:on-success="(value) => uploadSuccess('product_images', 'multi', value)">
						<i class="el-icon-plus"></i>
					</el-upload>
				</div>
			</el-form-item>
			<el-form-item label="商品详情" id="quill-upload">
				<el-upload :action="app_url + '/supplier/uploader/upload'"  multiple :show-file-list="false" :before-upload="beforeUpload" :on-success="editorSuccess"
					:on-error="uploadError" style="display: none;">
				</el-upload>
				<quill-editor ref="quill" v-model="item.introduction" :options="editorOption" @click.native="handleEditAblequestion"/>
			</el-form-item>
			<el-form-item v-if="canEdit" style="position: absolute;bottom: 10px;z-index: 1000">
				<el-button size="big" type="primary" @click="checkSubmit" v-auth="['supplier/product/edit']">保存并提交审核</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		quillEditor
	} from 'vue-quill-editor'
	export default {
		data() {
			return {
				item: {
					product_pic_main: '',
					product_images: [],
					supplier_category_id: 0
				},
				isLoad: false,
				id: this.$route.query.id,
				searchname:this.$route.query.name,
				search_supplier_category_id:this.$route.query.supplier_category_id,
				canEdit: true,
				authType: this.$route.query.authStatus ? this.$route.query.authStatus : -2,
				dialogVisible: false,
				product_images: [],
				product_pic_main: [],
				radio: "",
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				supplierCategoryList: [], // 店铺商品分类列表
				brandList: [], // 品牌列表
				adminCategoryList: [], // 平台商品分类列表
				industryTemplateList: [], // 行业模板
				parameter: [],
				deliverys: [],
				// 规格
				tableColumnList: {
					tableHeaderList: [],
					tableBodyList: []
				},
				privateGoodsItem: [],
				goods_option: [],
				// 方法的变量

				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								['blockquote', 'code-block'],
								[{
									'header': 1
								}, {
									'header': 2
								}],
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}],
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}],
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}],
								[{
									'direction': 'rtl'
								}],
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									'color': []
								}, {
									'background': []
								}],
								[{
									'font': []
								}],
								[{
									'align': []
								}],
								['clean'],
								['image', 'video']
							],
							handlers: {
								image: function(value) {
									if (value)
										document.querySelector('#quill-upload input').click()
									else
										this.quill.format('image', false);
								}
							}
						}
					},
				},
				rules: {
					counterName: [{
						required: true,
						message: '专柜名称不存在',
						trigger: 'blur'
					}, ],
					cost: [{
						validator: this.$check.bailPaid,
						trigger: 'blur'
					}, ],
					freight: [{
						validator: this.$check.bailPaid,
						trigger: 'blur'
					}, ],
					keyword: [{
						required: true,
						message: '搜索关键词不存在',
						trigger: 'blur'
					}, ],
					market_price: [{
						validator: this.$check.bailPaid,
						trigger: 'blur'
					}, ],
					maxCommission: [{
						validator: this.$check.bailPaid,
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '专柜名称不存在',
						trigger: 'blur'
					}, ],
					brand_id: [{
						required: true,
						message: '请选择所属品牌'
					}],
					product_category_id: [{
						required: true,
						message: '请选择平台分类'
					}],
					supplier_category_id: [{
						required: true,
						message: '请选择商品分类'
					}],
					price: [{
						validator: this.$check.bailPaid,
						trigger: 'blur'
					}, ],
					product_images: [{
						required: true,
						message: '商品图片不存在'
					}, ],
					product_pic_main: [{
						required: true,
						message: '商品主图不存在'
					}, ],
					sn: [{
						required: true,
						message: '编号不存在',
						trigger: 'blur'
					}, ],
					unit: [{
						required: true,
						message: '单位不存在',
						trigger: 'blur'
					}, ],
					weight: [{
						required: true,
						message: '重量不存在',
						trigger: 'blur'
					}, ],
				},
				// 批量设置表格data
				oneFormBatch: [
					{
						price: 0,
						market_price: 0,
						cost: 0,
						stock: 0,
						product_image: '',
						product_sku_no: ''
					},
				],
				qillInit: true
			}
		},
		computed: {
			// 规格发生变化的时候执行
			calculateAttribute() {
				let obj = {}
				//privateSpecName 规格名
				this.privateGoodsItem.forEach((item) => {
					if (item.privateSpecName) {
						// privateSpecName做键 item.dynamicTags做值
						//  规格名做键 规格值做值
						obj[item.privateSpecName] = item.dynamicTags
					}
				})
				return obj
			}
		},
		watch: {
			// 规格发生变化的时候执行 newVal就是上面的obj
			calculateAttribute(newVal) {
				// JSON.stringify() 方法用于将 JavaScript 值转换为 JSON 字符串。
				// JSON.parse() 方法将数据转换为 JavaScript 对象。
				let cloneNewVal = JSON.parse(JSON.stringify(newVal))
				let attrName = []
				let attrValue = []
				for (let key in cloneNewVal) {
					attrName.push(key)
					attrValue.push(cloneNewVal[key])
				}
				let finalArr = this.cartesianProductOf(...attrValue)
				let tableObj = {
					tableBodyList: [],
					tableHeaderList: []
				}
				tableObj.tableBodyList = finalArr.map((item, index) => {
					let obj = {
						id: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].id : '',
						price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].price :
							'',
						market_price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')]
							.market_price : '',
						cost: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].cost : '',
						product_image: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_image : '',
						product_sku_no: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_sku_no : '',
						unique: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].unique : '',
						product_id: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_id : ''
					}
					for (let i = 0; i < item.length; i++) {
						obj[attrName[i]] = item[i]
					}
					return obj
				})
				this.tableColumnList.tableBodyList = tableObj.tableBodyList
				let skuTableArr = Object.keys(newVal)
				tableObj.tableHeaderList = skuTableArr.map((item) => {
					return {
						prop: item,
						propName: item
					}
				})
				this.tableColumnList.tableHeaderList = tableObj.tableHeaderList
			}
		},
		created() {
			this.loadData()
		},
		mounted() {
			this.$refs.quill.quill.enable(false)
			this.$refs.goodsName.focus()
		},
		methods: {

			//methods里面  // 点击富文本重新获取焦点
			handleEditAblequestion () {
				if (this.qillInit) {
					this.$refs.quill.quill.enable(true)
					this.$refs.quill.quill.focus()
					this.qillInit = false
				}
			},
			// 批量添加
			batchAdd() {
				for (let val of this.tableColumnList.tableBodyList) {
					if (this.oneFormBatch[0].price > 0) {
						this.$set(val, "price", this.oneFormBatch[0].price);
					}
					if (this.oneFormBatch[0].market_price > 0) {
						this.$set(val, "market_price", this.oneFormBatch[0].market_price);
					}
					if (this.oneFormBatch[0].cost > 0) {
						this.$set(val, "cost", this.oneFormBatch[0].cost);
					}
					if (this.oneFormBatch[0].product_image != '') {
						this.$set(val, "product_image", this.oneFormBatch[0].product_image);
					}
					if (this.oneFormBatch[0].product_sku_no != '') {
						this.$set(val, "product_sku_no", this.oneFormBatch[0].product_sku_no);
					}
				}
			},
			batchDel() {
				this.oneFormBatch = [
					{
						price: 0,
						market_price: 0,
						cost: 0,
						product_image: '',
						product_sku_no: ''
					},
				];
			},
			loadData: async function() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad

				// 供应商：商品分类树
				await this.axios.get('/supplier/data/getCategoryTreeSupplier', {}).then(res => {
					this.supplierCategoryList = res.data.tree
				})

				// 中控：商品分类树
				await this.axios.get('/supplier/data/getCategoryTreeAdmin', {}).then(res => {
					this.adminCategoryList = res.data.tree
				})

				// 品牌列表
				await this.axios.get('/supplier/data/listBrandForSelect', {}).then(res => {
					this.brandList = res.data.list
				})

				await this.axios.get('/supplier/delivery/list', {}).then(res => {
					this.deliverys = res.data.list
				}).catch(() => {
				})

				// 获取商品信息
				await this.axios.post('/supplier/product/detail', {
					id: this.id
				}).then(res => {
					if(res.data.detail.specifications){
						res.data.detail.specifications.forEach(key => {
							key.specValue = key.specValue.split(',')
							key.inputVisible = false
							key.inputValue = ''
						})

						res.data.detail.specifications.forEach((key, index) => {
							this.$set(key, 'dynamicTags', key.specValue)
							this.$set(key, 'privateSpecName', key.specName)
							this.tableColumnList.tableHeaderList[index] = {}
							this.$set(this.tableColumnList.tableHeaderList[index], 'propName', key.specName)
							this.$set(this.tableColumnList.tableHeaderList[index], 'prop', key.specName)
						})
						this.privateGoodsItem = res.data.detail.specifications
					}

					res.data.detail.sku.forEach((key, index) => {
						let skuName1 = key.sku_name.split(',')
						let skuNameArr = ''
						for (let i = 0; i < skuName1.length; i++) {
							skuNameArr += skuName1[i] + '|'
						}
						skuNameArr = skuNameArr.substr(0, skuNameArr.length - 1)
						let obj = {
							id: key.id,
							price: key.price,
							market_price: key.market_price,
							cost: key.cost,
							product_image: key.product_image,
							product_sku_no: key.product_sku_no,
							unique: key.unique,
							product_id: key.product_id
						}
						this.goods_option[skuNameArr] = obj
					})

					this.item = res.data.detail
					this.item.is_marketable = this.item.is_marketable.toString()
					this.$forceUpdate()
				})
				// 根据商品分类supplier_category_id获取全部的模板 第一次进来
				await this.axios.get('/supplier/data/getIndustryTemplateListByProductCategoryId', {
					params: {
						id: this.item.supplier_category_id
					}
				}).then(res => {
					this.industryTemplateList = res.data
				})
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$route.params.searchname=this.searchname
				this.$route.params.search_supplier_category_id=this.search_supplier_category_id
				console.log(this.search_supplier_category_id)
				this.$router.back(-1)
			},
			checkSubmit() {
				// 存储图片且刷新 因为上传的和存储的图片不是同一个

				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},

			// 提交
			submit() {
				if (this.isLoad) {
					return
				}

				this.isLoad = !this.isLoad

				this.item.attr = this.parameter
				// 解析多规格
				let specifications = [];
				this.privateGoodsItem.forEach((item) => {
					//privateSpecName 规格名
					//dynamicTags 规格值
					if (item.privateSpecName) {
						let obj = {}
						obj.specName = item.privateSpecName;
						obj.specValue = item.dynamicTags.join(",");
						specifications.push(obj);
					}
				})
				this.item.specification = specifications;

				if(this.item.specification.length == 0){
					 this.$message.error({
						message: '规格不能为空'
					});
					return
				}

				// 解析SKU
				let sku = [];
				this.tableColumnList.tableBodyList.forEach((item) => {
					let obj = {}
					obj.cost = item.cost;
					obj.market_price = item.market_price;
					obj.price = item.price;
					obj.product_image = item.product_image;
					obj.product_sku_no = item.product_sku_no;
					let skuName = '';
					this.tableColumnList.tableHeaderList.forEach((i) => {
						if (skuName != '') {
							skuName += ',';
						}
						skuName += item[i.propName];
					})
					obj.skuName = skuName;

					sku.push(obj);
				})
				this.item.sku = sku;

				this.item.id = this.id

				let url = '/supplier/product/update'
				var form = JSON.parse(JSON.stringify(this.item))
				this.axios.put('/supplier/product/update', form)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},

			addPrivateSpec() {
				this.privateGoodsItem.push({
					privateSpecName: '',
					dynamicTags: [],
					inputVisible: false,
					inputValue: ''
				})
			},
			delPrivateSpec(index) {
				this.privateGoodsItem.splice(index, 1)
			},
			handleInputConfirm(val, attr) {
				if (val) {
					attr.dynamicTags.push(val)
				}
				attr.inputVisible = false
				attr.inputValue = ''
			},
			handleClose(tag, item) {
				item.dynamicTags.splice(item.dynamicTags.indexOf(tag), 1)
			},
			showInput(attr, index) {
				attr.inputVisible = true
				this.$nextTick(() => {
					this.$refs[`saveTagInput${index}`][0].$refs.input.focus()
				})
			},
			cartesianProductOf(...args) {
				return args.reduce((total, current) => {
					let ret = []
					total.forEach((a) => {
						current.forEach((b) => {
							ret.push(a.concat([b]))
						})
					})
					return ret
				}, [
					[]
				])
			},


			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
					return false;
				}
				const isLt500KB = file.size / 1024 / 1024 < 5;
				if (!isLt500KB) {
					this.$message({
						message: "上传的文件大小不能超过 5M!",
						type: "warning",
					});
					return false;
				}
				return extension;
			},
			uploadSuccess(key, model, res, file) {
				if (model == 'single') {
					this.item[key] = res.data.fileInfo.external_url
				} else {
					this.item[key].push(res.data.fileInfo.external_url)
				}

			},
			uploadSuccess1(key, model, res, index) {
				if (key == 'oneFormBatch') {
					this.oneFormBatch[index].product_image = res.data.fileInfo.external_url
				} else {
					this.tableColumnList.tableBodyList[index].product_image = res.data.fileInfo.external_url
				}

				this.$forceUpdate()
			},
			delectImage: function (key, index) {
				this.item[key].splice(index, 1)
			},
			// 富文本图片上传
			editorSuccess(res) {
				let quill = this.$refs.quill.quill
				let length = quill.getSelection().index
				// 上传图片的路径
				quill.insertEmbed(length, 'image', res.data.fileInfo.external_url)
				quill.setSelection(length + 1)
				this.$message.success({
					message: '上传成功'
				});
			}
		},
		components: {
			quillEditor
		}
	}
</script>
<style scoped>
	.goods-spec {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.goods-spec .goods-spec-add {
		margin-left: 30px;
		margin-bottom: 14px;
	}

	.goods-container .button-new-tag {
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.goods-container .input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}

	.goods-container .el-tag {
		margin-right: 10px;
	}

	.goods-container .goods-content {
		margin-bottom: 10px;
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background-color: #fcfcfc;
	}

	.goods-content .goods-content-box {
		display: flex;
		align-items: center;
	}

	.goods-content-box .goods-content-left {
		flex: 1;
	}

	.single-image .icon,.single-image img{
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		width: 148px;
		height: 148px;
		cursor: pointer;
		line-height: 146px;
		vertical-align: top;
	}
	/deep/.ql-container{
		min-height: 200px;
	}
</style>
